var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rbd-app",attrs:{"id":"app"}},[_c('a-config-provider',{attrs:{"locale":_vm.zhCN}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }